import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

type StyledCobrandWebSmallBannerProps = {
  $enableECMVariation: boolean | undefined;
};

export const StyledCobrandWebSmallBanner = styled.div<StyledCobrandWebSmallBannerProps>`
  /* clamp (minVal : fallback if scaling value falls below minValue, scaling value, maxValue : fallback if scaling value falls below minValue) */
  /* calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width]))) */
  padding-top: ${({ $enableECMVariation }) =>
    $enableECMVariation
      ? '0'
      : `clamp(${toRem(62)}, calc(${toRem(62)} + 24 * ((100vw - ${toRem(365)}) / 211)), ${toRem(86)})`};
  @media ${baseVariables.mediaQuery.md} {
    padding-top: 0;
  }
  margin: 0 auto;
  .card-container {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    border: ${baseVariables.border['borderWidth02']} solid ${baseVariables.color['neutral20']};
    background: white;
    border-radius: ${baseVariables.border['borderRadiusDefault']};
    padding: 0 ${toRem(24)};
    box-shadow: ${baseVariables.shadows['shadowSubtle01']};
    @media ${baseVariables.mediaQuery.md} {
      flex-direction: row;
      align-items: ${({ $enableECMVariation }) => ($enableECMVariation ? 'stretch' : 'center')};
      padding: ${({ $enableECMVariation }) => ($enableECMVariation ? `${toRem(24)}` : `${toRem(12)} ${toRem(24)}`)};
    }
    p {
      margin: 0;
    }
    input[type='checkbox'] + label {
      @media ${baseVariables.mediaQuery.md} {
        margin-bottom: ${toRem(0)};
      }
      margin-bottom: ${toRem(8)};
    }
    .image-container {
      margin-top: clamp(${toRem(-72)}, calc(-1 * (${toRem(48)} + 24 * ((100vw - ${toRem(365)}) / 211))), ${toRem(-48)});
      @media ${baseVariables.mediaQuery.sm} {
        margin-top: -${toRem(68)};
      }
      @media ${baseVariables.mediaQuery.md} {
        margin-top: 0;
        padding-right: ${toRem(24)};
        display: flex;
        justify-content: center;
      }
      img {
        width: clamp(${toRem(170)}, calc(${toRem(170)} + 130 * ((100vw - ${toRem(365)}) / 211)), ${toRem(300)});
        @media ${baseVariables.mediaQuery.md} {
          width: ${toRem(122)};
        }
      }
    }
    .flexible-card {
      display: flex;
      padding-top: ${({ $enableECMVariation }) => ($enableECMVariation ? toRem(24) : toRem(16))};
      text-align: center;
      flex-direction: column;
      width: ${({ $enableECMVariation }) => ($enableECMVariation ? toRem(327) : 'auto')};
      @media ${baseVariables.mediaQuery.sm} {
        padding-top: ${toRem(24)};
      }
      @media ${baseVariables.mediaQuery.md} {
        flex: ${({ $enableECMVariation }) => ($enableECMVariation ? '0 0 auto' : '1')};
        padding: 0;
        text-align: left;
      }
      .ecm-card-ending {
        margin-top: ${toRem(4)};
        color: ${baseVariables.color['neutral40']};
        font-weight: 700;
        text-align: center;
        @media ${baseVariables.mediaQuery.md} {
          text-align: left;
        }
      }
      .ecm-card-ending-skeleton {
        margin-top: ${toRem(4)};
        text-align: center;
        @media ${baseVariables.mediaQuery.md} {
          text-align: left;
          margin-top: ${toRem(2)};
        }
      }
    }

    .ecm-cta-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      @media ${baseVariables.mediaQuery.md} {
        justify-content: flex-end;
        align-items: flex-end;
        width: auto;
      }
    }
    .flexible-card-content-container {
      display: contents;
    }
    .flexible-click {
      margin-top: ${toRem(24)};
      margin-bottom: ${toRem(32)};
    }
  }
  p {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .card-img-styles {
    width: ${({ $enableECMVariation }) => ($enableECMVariation ? toRem(190) : toRem(155))};
    @media ${baseVariables.mediaQuery.md} {
      width: ${({ $enableECMVariation }) => ($enableECMVariation ? toRem(190) : toRem(113))};
    }
  }
  .card-img-container {
    margin-top: ${({ $enableECMVariation }) => ($enableECMVariation ? toRem(24) : `-${toRem(56)}`)};
    @media ${baseVariables.mediaQuery.md} {
      margin-top: 0;
    }
  }
`;
